module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/listaofferte/listaofferte.component.scss
// module id = ./src/app/listaofferte/listaofferte.component.scss
// module chunks = main